import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    box-sizing: border-box;
    position: relative;
`;

const PageTemplate = ({ children, ...props }) => {
    return <Wrapper {...props}>{children}</Wrapper>;
};

export default PageTemplate;
